import { Box, Button, Chip, Grid, Stack, Typography, useTheme } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from "react-i18next";
import StarsIcon from '@mui/icons-material/Stars';
import { useNavigate } from "react-router-dom";
import { GetTheme, THEME } from "../../theme/customThemeProvider";

const BlogDetails = ({
    data, 
    featuredBlog=false,
    customFeatureTag="",
    readActionTxt=""
}) => {
    const theme = useTheme();
    const {themeMode} = GetTheme();

    const {t} = useTranslation();

    const navigate = useNavigate();

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='center'
                container
                width='100%'
                spacing={{xs: 1, md: featuredBlog ? 5 : 2}}
                data-aos="slide-up"
            >
                <Grid size={{xs: 12, md: featuredBlog ? 6 : 12}}>
                    <Box
                        width='100%'
                    >
                        <img 
                            src={data.image}
                            alt={data.title}
                            width='100%'
                            style={{
                                aspectRatio: 16/9,
                                borderRadius: '16px'
                            }}
                        />
                    </Box>
                </Grid>

                <Grid size={{xs: 12, md: featuredBlog ? 6 : 12}}>
                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='start'
                        spacing={{xs: 1.5, md: 2}}
                        px={1}
                        pt={{xs: 1, md: 0}}
                    >
                        {
                            featuredBlog
                            ?
                            <Chip 
                                label={customFeatureTag ? customFeatureTag : t('blogs.featured')}
                                icon={<StarsIcon style={{color: 'white'}}/>}
                                sx={{
                                    color: 'white',
                                    backgroundColor: theme.palette.primary.main
                                }}
                            />
                            :
                            <></>
                        }

                        <Typography
                            fontWeight={{xs: 600, lg: featuredBlog ? 500 : 600}}
                            fontSize={{xs: 16, lg: featuredBlog ? 50 : 20}}
                            textAlign='left'
                            lineHeight={{xs: 1.25, lg: featuredBlog ? 1 : 1.25}}
                            color={theme.palette.text.primary}
                        >
                            {data.title}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, lg: 16}}
                            textAlign='justify'
                            lineHeight={{xs: 1.25, lg: 1.5}}
                            color={theme.palette.text.secondary}
                        >
                            {data.description}
                        </Typography>

                        <Button 
                            variant="text" 
                            endIcon={<ArrowForwardIcon />}
                            disableRipple
                            sx={{
                                textTransform: 'none',
                                m: 0,
                                p: 0,
                                backgroundColor: 'transparent',
                                color: themeMode == THEME.LIGHT ? theme.palette.primary.main : theme.palette.primary.contrastText,
                                '&: hover': {
                                    transform: 'scale(1.1)',
                                    backgroundColor: 'transparent'
                                }
                            }}
                            onClick={() => {
                                window.open(data.src, '_blank');
                            }}
                        >
                            {readActionTxt ? readActionTxt : t('blogs.read')}
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
}

export default BlogDetails;